/**
 * Notifications API schemas
 *
 * Export all Zod schemas and types for notification endpoints
 */

export * from './delete';
export * from './read-all';
export * from './unread-counts';

// Re-export schemas from list
export {
  GetNotificationsQuerySchema,
  NotificationSchema as NotificationListSchema,
  GetNotificationsResponseSchema,
} from './list';

// Re-export types from list
export type {
  GetNotificationsQuery,
  Notification as NotificationList,
  GetNotificationsResponse
} from './list';

// Re-export schemas from read
export {
  NotificationMarkReadParamSchema,
  NotificationSchema as NotificationReadSchema,
  MarkReadSuccessResponseSchema,
  NotificationMarkReadResponseSchema,
} from './read';

// Re-export types from read
export type {
  NotificationMarkReadParam,
  Notification as NotificationRead,
  MarkReadSuccessResponse,
  NotificationMarkReadResponse
} from './read';
